import { Injectable } from '@angular/core';
import * as onscan from 'onscan.js';
import { from, fromEvent, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

/*
  Used library https://github.com/axenox/onscan.js/
  To simulate barcode scanner execute in browser console:
  onScan.simulate(document, '123456789');
 */

interface BarcodeScannerEvent {
  detail: {
    scanCode: string;
  };
}

@Injectable()
export class BarcodeScannerService {

  constructor() {
    onscan.attachTo(document);
    window['onScan'] = onscan;
  }

  listen(): Observable<string> {
    return from(['scan'])
      .pipe(
        mergeMap((event) => fromEvent(document, event)),
        map((event: any) => event as BarcodeScannerEvent),
        map(event => event?.detail?.scanCode)
      );
  }
}
